import { useContext, createContext, useEffect,useState } from "react";
const AuthContext = createContext();

const AuthProvider = (props) => {
  const {token,user,role,logOut,additionalUserInfo,setAdditionalUserInfo,setRole}=props;
 
  return <AuthContext.Provider value={{ token,user,role,additionalUserInfo,setAdditionalUserInfo,setRole }}>{props.children}</AuthContext.Provider>;
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};